export default `float sdOctahedron( in vec3 p, in float s)
      p = abs(p);
      float m = p.x+p.y+p.z-s;
      vec3 q;
           if( 3.0*p.x < m ) q = p.xyz;
      else if( 3.0*p.y < m ) q = p.yzx;
      else if( 3.0*p.z < m ) q = p.zxy;
      else return m*0.57735027;

      float k = clamp(0.5*(q.z-q.y+s),0.0,s);
      return length(vec3(q.x,q.y-s+k,q.z-k));
  }

  float de(vec3 op){
    vec3 b = vec3(1.0,2.0,3.0); 
    float ch = 0.25;      
    float r = 0.05;       

    vec3 p = abs(op)+vec3(ch)+vec3(r);
    p = max(vec3(0.0),p-b);
    float d =fOctahedron(p,ch);
    return d-r ;
  }`